export default function Voice() {
  return (
    <svg fill='none' height='32' viewBox='0 0 32 32' width='32' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.6463 9C15.617 10.0871 16.2001 11.4806 16.2001 13C16.2001 14.5194 15.617 15.9129 14.6463 17'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M12.2048 10.3223C12.8519 11.0501 13.2406 11.983 13.2406 13.0002C13.2406 14.0174 12.8519 14.9504 12.2048 15.6782'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M9.79999 11.7461C10.1004 12.087 10.2809 12.5239 10.2809 13.0003C10.2809 13.4767 10.1004 13.9137 9.79999 14.2546'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M23 12.4412V12.4412C23 7.22696 18.773 3 13.5588 3H13C7.47715 3 3 7.47715 3 13V13.5882C3 18.7862 7.21379 23 12.4118 23V23'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <image height='14' href='/assets/images/omnibox/voice-preview.png' width='14' x='16' y='16' />
    </svg>
  );
}
